<kl-grid
  [columns]="[
    {
      header: 'status' | translate,
      binding: 'status',
      translate: true,
      visible: true
    },
    { header: 'fullname' | translate, binding: 'full_name', visible: true },
    {
      header: 'username' | translate,
      binding: 'username',
      size: '*',
      visible: true
    },
    {
      header: 'current_account' | translate,
      binding: 'current_account.description',
      size: '*',
      visible: true
    }
  ]"
  [filterable]="true"
  [deferResizing]="false"
  [tabId]="tabId || modalId"
  [filterSelectItems]="filterSelectItems"
  [mode]="'DIALOG'"
  [modalClass]="'modal-dialog modal-m'"
  [service]="{
    service: 'installation-user',
    name: 'installation_users',
    form: 'INSTALLATION_USER',
    showButton: true,
    showDropDownButton: true
  }"
  [parentModuleName]="'MANAGEMENT'"
  [moduleName]="'INSTALLATION_USER_LIST'"
  [gridName]="'grdInstallationUserList'"
>
</kl-grid>
